// Lazy-load Stripe.js (only when the wallet method is actually used).
let loading = null;

export function loadStripeJs() {
  if (typeof window !== 'undefined' && window.Stripe) return Promise.resolve(window.Stripe);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://js.stripe.com/v3/';
    s.async = true;
    s.onload = () => (window.Stripe ? resolve(window.Stripe) : reject(new Error('stripe-not-ready')));
    s.onerror = () => reject(new Error('stripe-load-failed'));
    document.head.appendChild(s);
  });
  return loading;
}
